/***
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 * @hidden
 * @format
 **/
export type hidden = 1;

export type OmnHorizonClientAPIVersion = 1|2|3;

export type OmnHorizonClientTypes = "ChromeNative" | "IsolatedWebApp";

export type OmnHorizonClientVChanAPIVersion = 3;

export type OmnHorizonClientEventsVersion = 3;

export type OmnHorizonLaunchItemType =
   | "HorizonDesktop"
   | "HorizonApp"
   //XenApp |
   //SaaSApp |
   | "HorizonAppSession" // Disconnected app session
   | "DesktopShadowSession"
   | "AppShadowSession";

/*
 * subset of set coresponding to
  Unknown = 0,
  Disclaimer,
  SecurID_Passcode,
  SecurID_NextTokencode,
  SecurID_PIN_Change,
  SecurID_Wait,
  Windows_Password,
  Windows_Password_Expired,
  Certificate,
  SAML,
  GSSAPI,
  Unauthenticated_Access
 */
export type OmnHorizonClientAuthType = "Not_Allowed" | "Disclaimer" | "SAML" | "Windows_Password"; //used for indicate authentication error for now

// bitmask, should be used to parse the supported protocols from the "protocol number" for entitlement items.
// when launching items, should only use one protocol.
export type OmnHorizonClientProtocol = "Default" | "Blast"; // Chrome client doesn't support "RDP" or "PCoIP"

export type OmnHorizonClientSessionType = "App" | "Desktop";

export type OmnHorizonClientDisplayType = "Default" | "WindowSmall" | "WindowLarge" | "Fullscreen" | "Multimonitor";

export type OmnHorizonServerType = "Horizon";
//WorkspaceOne

export type OmnHorizonClientSeamlessWindowType =
   | "None"
   | "Normal"
   | "Panel"
   | "Dialog"
   | "Menu"
   | "Tooltip"
   | "Splash"
   | "Toolbar"
   | "Dock"
   | "Desktop"
   | "Combobox"
   | "Widget"
   | "StartScreen"
   | "SlideInPanel"
   | "Taskbar"
   | "Metro"
   | "ShellSystemDialog";

export type OmnHorizonClientAllowedOperations = "Disconnect" | "Log off" | "Reset" | "Restart" | "Terminate";

export type OmnHorizonClientRemoteSessionOperation = "Disconnect";

export type OmnHorizonClientLogLevel = "None" | "Error" | "Warning" | "Info" | "Debug" | "Trace";
